import React from 'react';
import { ThemeProvider } from 'styled-components';

import getTheme from 'utils/getTheme';

interface Props {
  children: React.ReactNode;
}
const ThemeProviderWrapper = ({ children }: Props) => {
  const theme = getTheme();

  const safeAreaInsetTop = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue('--sat'),
  );

  const safeAreaInsetBottom = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue('--sab'),
  );

  return (
    <ThemeProvider
      theme={{
        ...theme,
        safeAreaInsetBottom,
        safeAreaInsetTop,
      }}>
      {children}
    </ThemeProvider>
  );
};

export default ThemeProviderWrapper;
